import { ITableFilters } from '@interfaces';
import { createContext, ReactNode, useContext, useState } from 'react';

interface IData {
    id: string;
    name: string;
}
export interface IBrand {
    id: string;
    name: string;
    charges: number;
}
export interface IApr {
    id: string;
    amount: number;
    rate: number;
}
export interface IInstallmentPlans {
    id: string;
    name: string;
    cycle: number;
}
interface IDate {
    startDate: string;
    endDate: string;
}

export interface ILeadContext {
    date: IDate;
    allCustomersFiltars: ITableFilters;
    approvedCustomersFiltars: ITableFilters;
    cashCustomersFiltars: ITableFilters;
    setDate: (date: IDate) => void;
    setAllCustomersFiltars: (data: ITableFilters) => void;
    setApprovedCustomersFiltars: (data: ITableFilters) => void;
    setCashCustomersFiltars: (data: ITableFilters) => void;
}

const CustomerContext = createContext<ILeadContext | undefined>(undefined);

const EMPTY_FILTERS_ITEM: ITableFilters = {
    agent: [],
    status: [],
    city: [],
    segment: [],
    productType: [],
    channel: [],
    quantity: null,
    brand: [],
    createdAt: null,
    searchedText: '',
    province: [],
    customerStatus: [],
};

export const CustomerContextProvider = ({ children }: { children: ReactNode }) => {
    const [date, setDate] = useState<IDate>({ startDate: '', endDate: '' });

    const [allCustomersFiltars, setAllCustomersFiltars] = useState<ITableFilters>(EMPTY_FILTERS_ITEM);
    const [approvedCustomersFiltars, setApprovedCustomersFiltars] = useState<ITableFilters>(EMPTY_FILTERS_ITEM);
    const [cashCustomersFiltars, setCashCustomersFiltars] = useState<ITableFilters>(EMPTY_FILTERS_ITEM);

    return (
        <CustomerContext.Provider
            value={{
                date,
                setDate,
                allCustomersFiltars,
                setAllCustomersFiltars,
                approvedCustomersFiltars,
                setApprovedCustomersFiltars,
                cashCustomersFiltars,
                setCashCustomersFiltars,
            }}
        >
            {children}
        </CustomerContext.Provider>
    );
};

export const useCustomerContext = () => {
    const context = useContext(CustomerContext);
    if (!context) {
        throw new Error('useLeadContext must be used within a LeadProvider');
    }
    return context;
};
